import Vue from 'vue'
import qs from 'qs'

export default {
  get (locationId, page, limit, order, sort, filters) {
    const params = {
      page,
      limit,
      order,
      sort,
      filters,
      location_id: locationId
    }

    return Vue.http.get(`/transactions`, {
      params,
      paramsSerializer: qs.stringify
    })
  }
}
